export default __webpack_public_path__ + "static/media/P900_SOV.0cf6486e.pdf";